module.exports = __webpack_public_path__ + "icon-attention.png?94f4ca141c03eb9bb1e08f3c30608346";